module.exports = {
  'selectLanguage': 'Choisissez votre langue',
  '404Title': 'Page non trouvée'
};